module.exports = __webpack_public_path__ + "static/image16@2x-dcb263bf008d1201a5cde7209c1a6b80.png";